import { AxiosResponse } from "axios";
import { HttpCode } from "../http-code";
import { RequestResponse } from "../types";
import { NotifyCenter } from "project-config/services/notify-center";
import request from "../request";
import { Cookie } from "../../../utils";
import { goToMainRoute } from "../../../utils/env";
import {
  CONST_API_ALLOWED_LISTS,
  CONST_ROUTE_ALLOWED_LISTS,
} from "../constants/default";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
/*@ts-ignore*/

interface IErrorInfoData {
  event: string;
  data: {
    user_id: string;
    zone: number;
    browser: string;
    url: string;
    errorInfo: string;
    time: number;
  };
}

export const NO_RECORD_ERROR_API = ["/client/desktop/qclient/changelog.php"];

export default async function responseInterceptors(
  response: AxiosResponse<RequestResponse<any>>
) {
  const { code, requestId, data } = response.data;
  NotifyCenter.axiosResponseInterceptor.emit(response);
  // 错误信息上传（记录除200状态码之外的其他错误信息
  // if (![200, "Common.Success"].includes(code) && !(!data && !code)) {
  //   await request.post<IErrorInfoData[]>(
  //     "/api/rendering/buriedpointdata/collector/data",
  //     {
  //       event: "errorInfo",
  //       data: {
  //         user_id: localStorage.getItem(STORAGE.USER_ID),
  //         zone: getDomain() ? 2 : 1,
  //         browser: getCurrentBroswerName(),
  //         url: response.config.url,
  //         errorInfo: requestId,
  //         time: +new Date(),
  //       },
  //     }
  //   );
  // }

  if (
    [HttpCode.NeedUserLogin, HttpCode.NeedUserLogin2].includes(code) &&
    !CONST_ROUTE_ALLOWED_LISTS.includes(window.location.pathname) &&
    !CONST_API_ALLOWED_LISTS.includes(response.config.url || "")
  ) {
    if (Cookie.getCookie("rayvision_userKey")) {
      await request.post("/api/rendering/user/clearCookies", {
        cookieName: "rayvision_userKey",
      });
    }
    goToMainRoute();
  }

  return response;
}
